import EventEmitter from "../Utils/EventEmitter.js";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { SplitText } from "../../../../vendors/gsap/SplitText";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

export default class UI extends EventEmitter{
    static _instance = null;

    static getInstance() {
        return UI._instance || new UI();
    }

    constructor(parent) {
        super();
        this.parent = parent || document;
        if (UI._instance) {
            return UI._instance;
        }

        UI._instance = this;

        this.experience = window.experience;

        this.scroller = window.scroller // LocomotiveScroll instance
        this.isMobile = this.scroller.scroll.isMobile;

        this.setViewportHeight();
        this.init();
    }

    setViewportHeight() {
        // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        // let vh = window.innerHeight * (isIOS ? 0.012 : 0.01);
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    initPreloader() {
        this.html.preloader = {
            el : this.parent.getElementById("preloader")
        }

        this.html.preloader.progressEl = this.html.preloader.el.querySelector('.preloader--progress')
        this.html.preloader.progressBarEl = this.html.preloader.el.querySelector('.preloader--progress-bar')
        this.html.preloader.textEl = this.html.preloader.el.querySelector('.preloader--logo')
        this.html.preloader.placeholderEl = this.html.preloader.el.querySelector('.preloader--placeholder')
        this.html.preloader.overlayEl = this.html.preloader.el.querySelector('.preloader--overlay')
    }

    setPreloaderProgress(progress) {
        gsap.to(this.html.preloader.progressBarEl, {
            width: `${progress}%`,
            duration: 0.5,
            ease: "power4.inOut",
        });
    }

    hidePreloader() {
        const tl = gsap.timeline({
            onComplete: () => {
                this.html.preloader.el.style.display = 'none'

                this.runAnimation('heroTitle')
            }
        });

        tl
            .to(this.html.preloader.progressEl, {
                y: "+=30",
                opacity: 0,
                duration: 0.5,
                ease: "power4.inOut",
            }, 0.5)
            .to(this.html.preloader.textEl, {
                y: "-=30",
                opacity: 0,
                duration: 0.5,
                ease: "power4.inOut"
            }, 0.5)
            .to(this.html.preloader.el, {
                opacity: 0,
                duration: 1,
                ease: "power4.inOut",
            }, 0.8)
    }

    init() {
        this.html = {}
        this.html.body = document.body;
        this.html.title = this.parent.getElementById("hero-title");
        this.html.hero = this.parent.getElementById("cyber60-hero");
        this.html.presented = this.parent.querySelector('.presented-by')
        this.html.heroLogo = this.parent.querySelector('.hero--content-left .logo')
        this.html.heroInfo = this.parent.querySelector('#hero-info')

        this.animations = {}

        this.initPreloader()
        this.initTitleParallax()
        this.initContentBackground()

        if(!this.isMobile) {
            this.initHeroParallax();
        } else {

        }
    }

    initContentBackground() {
        this.html.backgroundEl = this.parent.getElementById('cyber60-content-background')

        ScrollTrigger.create({
            trigger: '#cyber60-main',
            endTrigger: '.cyber60--content',
            scroller: '[data-scroll-container]',
            invalidateOnRefresh: true,
            scrub: true,
            start: 'top top',
            end: 'bottom bottom',
            onUpdate: (self) => {
                this.trigger('backgroundUpdate', [self.progress]);
            }
        })

        if(this.isMobile) {
            ScrollTrigger.create({
                trigger: '#cyber60-main',
                endTrigger: '.cyber60--content',
                pin: "#cyber60-content-background",
                pinType: 'fixed',
                pinSpacing: false,
                scroller: '[data-scroll-container]',
                invalidateOnRefresh: true,
                scrub: true,
                start: 'top top',
                end: 'bottom bottom',
                onUpdate: (self) => {
                    this.trigger('backgroundUpdate', [self.progress]);
                }
            })
        } else {
            ScrollTrigger.create({
                trigger: '#cyber60-main',
                endTrigger: '.cyber60--content',
                scroller: '[data-scroll-container]',
                invalidateOnRefresh: true,
                scrub: true,
                start: 'top top',
                end: 'bottom bottom',
                onUpdate: (self) => {
                    this.trigger('backgroundUpdate', [self.progress]);
                }
            })
        }
    }

    runAnimation(animation) {
        if (!this.animations[animation]) return;
        this.animations[animation].play();
    }

    initTitleParallax() {
        this.html.title = this.html.hero.querySelector('h1')
        this.html.titleSplit = new SplitText(this.html.title, { type: "lines,words,chars", charsClass: 'js-letter' });
        this.html.titleLetters = this.html.titleSplit.chars;
        this.html.titleLines = this.html.titleSplit.lines;

        this.html.titleLines.forEach((line, i) => {
            line.classList.add(`js-line-${i}`)
        })

        this.html.titleLetters.forEach((letter, i) => {
            return letter.innerHTML = '<div class="js-inner">' + letter.innerHTML + '</div>'
        })

        this.html.titleLettersInner = [...this.html.title.querySelectorAll('.js-inner')]

        this.html.subtitle = this.html.hero.querySelector('h2')
        this.html.subtitleSplit = new SplitText(this.html.subtitle, { type: "lines,words,chars", charsClass: 'js-letter' });
        this.html.subtitleLetters = this.html.subtitleSplit.chars;
        this.html.subtitleLines = this.html.subtitleSplit.lines;

        this.html.subtitleLines.forEach((line, i) => {
            line.classList.add(`js-line-${i}`)
        })

        this.html.subtitleLetters.forEach((letter, i) => {
            return letter.innerHTML = '<div class="js-inner">' + letter.innerHTML + '</div>'
        })

        this.html.subtitleLettersInner = [...this.html.subtitle.querySelectorAll('.js-inner')]

        this.animations.heroTitle = gsap.timeline({
            paused: true
        });
        if(this.html.titleLettersInner.length) {
            this.animations.heroTitle.to(this.html.titleLettersInner, {
                y: 0,
                duration: 1,
                stagger: 0.03,
                ease: "power4.inOut",
            })
        }
        if(this.html.subtitleLettersInner.length) {
            this.animations.heroTitle.to(this.html.subtitleLettersInner, {
                y: 0,
                duration: 1,
                stagger: 0.03,
                ease: "power4.inOut",
            },0.4)
        }

        this.animations.heroTitle.to('.cyber60-hero--content--arrow', {
                opacity: 1,
                duration: 0.5,
                ease: "power4.inOut",
            }, 1)

        let timelineDelay = 1;

        if(this.html.heroLogo) {
            gsap.set(this.html.heroLogo, {
                opacity: 0,
                y: 20,
            })

            this.animations.heroTitle.to(this.html.heroLogo, {
                opacity: 1,
                y: 0,
                duration: 1.3,
                ease: "power3.inOut",
            }, timelineDelay)

            timelineDelay += 0.2;
        }

        if(this.html.heroInfo) {
            gsap.set(this.html.heroInfo, {
                opacity: 0,
                y: 20,
            })

            this.animations.heroTitle.to(this.html.heroInfo, {
                opacity: 1,
                y: 0,
                duration: 1.3,
                ease: "power3.inOut",
            }, timelineDelay)

            timelineDelay += 0.2;
        }

        if(this.html.presented) {
            this.animations.heroTitle.to(this.html.presented, {
                opacity: 1,
                x: 0,
                duration: 1.3,
                ease: "power3.inOut",
            }, timelineDelay)
        }
    }

    onScroll(e) {
        this.trigger('smooth-scroll', e);
        ScrollTrigger.update();
    }

    update(time) {

    }

    initHeroParallax() {
        /*gsap.to(this.html.hero, {
            scrollTrigger: {
                trigger: this.html.hero,
                start: "bottom 80%",
                end: "bottom top",
                scrub: true,
                invalidateOnRefresh: true,
                scroller: "[data-scroll-container]",
            },
            y: "50%",
            ease: "none",
        });*/
    }

    destroy() {
        if (this.scroller) {
            this.scroller.off('scroll', this.onScroll);
        }

        this.off('backgroundUpdate');

        gsap.killTweensOf(this.html.titleLettersInner);
        gsap.killTweensOf(this.html.subtitleLettersInner);
        gsap.killTweensOf('.cyber60-hero--content--arrow');

        if (this.animations.heroTitle) {
            this.animations.heroTitle.kill();
        }

        ScrollTrigger.getAll().forEach(st => st.kill());

        document.documentElement.style.removeProperty('--vh');
        UI._instance = null;
        this.html = null;
    }
}
